import {getCurrentYear} from '../../utils/commons'
import BestMotorGearPicksLogo from './logo'
import {bestMotorGearPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestmotorgearpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Motor Gear Picks',
  logo: <BestMotorGearPicksLogo className="size-12 shrink-0 tablet:size-10" />,
  favicon: '/favicons/bestmotorgearpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-NDSXHCBX8K',
    camelCaseUrl: 'BestMotorGearPicks.com',
    title: (category: string, count: string) =>
      `Best ${count} ${category} to Buy in ${getCurrentYear()} | BestMotorGearPicks.com – Honest Reviews & Top Car Gear Picks`,
    description: (category?: string, count?: string) =>
      `Explore the best ${count} ${category} for ${getCurrentYear()} at BestMotorGearPicks.com. Expert automotive reviews, detailed comparisons, and smart driving gear tips for performance and safety.`,
    styles: bestMotorGearPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
